"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LCE_IS_FETCHING = exports.LCE_NOT_REQUESTED = exports.LCEType = void 0;
/**
 * Mutually exclusive type of an LCE object
 */
var LCEType;
(function (LCEType) {
    LCEType[LCEType["NotRequested"] = 0] = "NotRequested";
    LCEType[LCEType["Fetching"] = 1] = "Fetching";
    LCEType[LCEType["Content"] = 2] = "Content";
    LCEType[LCEType["Error"] = 3] = "Error";
})(LCEType = exports.LCEType || (exports.LCEType = {}));
/**
 * Static @type NOT_REQUESTED. Useful to help avoid recreating an `lceNotRequested()` ref.
 */
exports.LCE_NOT_REQUESTED = Object.freeze({ type: LCEType.NotRequested });
/**
 * Static @type LCE_IS_FETCHING. Useful to help avoid recreating an `lceFetching()` ref.
 */
exports.LCE_IS_FETCHING = Object.freeze({ type: LCEType.Fetching });
//# sourceMappingURL=models.js.map